import PropTypes from 'prop-types';

export const Icons = ({ testid, className, variant, onClick, color, svgClass }) => {
  const renderIcon = () => {
    switch (variant) {
      case Icons.SIGNALS: {
        return (
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M18.9159 11.7379C19.8177 8.10966 25.0163 8.23272 25.7454 11.8995L29.8501 32.5439L31.4379 26.1557C31.8257 24.5953 33.2267 23.4999 34.8345 23.4999H43C44.3807 23.4999 45.5 24.6192 45.5 25.9999C45.5 27.3806 44.3807 28.4999 43 28.4999H36.0073L33.0841 40.2616C32.1823 43.8898 26.9837 43.7668 26.2546 40.0999L22.1499 19.4556L20.5621 25.8441C20.1743 27.4044 18.7733 28.4999 17.1655 28.4999H9C7.61929 28.4999 6.5 27.3806 6.5 25.9999C6.5 24.6192 7.61929 23.4999 9 23.4999H15.9927L18.9159 11.7379Z"
              fill="#51BFE1"
            />
          </svg>
        );
      }

      case Icons.CONDO: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            fill="none"
          >
            <path
              d="M15 20.75V4.25H3.75V20.75H15ZM15 20.75H20.9982V9.5L14.9982 8"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M7.5 20.75V17H11.25V20.75"
              stroke="#515151"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M6.5 7.45C6.5 7.20147 6.69188 7 6.92857 7H7.78571C8.02241 7 8.21429 7.20147 8.21429 7.45V8.35C8.21429 8.59853 8.02241 8.8 7.78571 8.8H6.92857C6.69188 8.8 6.5 8.59853 6.5 8.35V7.45Z"
              fill="#515151"
            />
            <path
              d="M6.5 10.45C6.5 10.2015 6.69188 10 6.92857 10H7.78571C8.02241 10 8.21429 10.2015 8.21429 10.45V11.35C8.21429 11.5985 8.02241 11.8 7.78571 11.8H6.92857C6.69188 11.8 6.5 11.5985 6.5 11.35V10.45Z"
              fill="#515151"
            />
            <path
              d="M6.5 13.45C6.5 13.2015 6.69188 13 6.92857 13H7.78571C8.02241 13 8.21429 13.2015 8.21429 13.45V14.35C8.21429 14.5985 8.02241 14.8 7.78571 14.8H6.92857C6.69188 14.8 6.5 14.5985 6.5 14.35V13.45Z"
              fill="#515151"
            />
            <path
              d="M10.5 7.45C10.5 7.20147 10.6919 7 10.9286 7H11.7857C12.0224 7 12.2143 7.20147 12.2143 7.45V8.35C12.2143 8.59853 12.0224 8.8 11.7857 8.8H10.9286C10.6919 8.8 10.5 8.59853 10.5 8.35V7.45Z"
              fill="#515151"
            />
            <path
              d="M10.5 10.45C10.5 10.2015 10.6919 10 10.9286 10H11.7857C12.0224 10 12.2143 10.2015 12.2143 10.45V11.35C12.2143 11.5985 12.0224 11.8 11.7857 11.8H10.9286C10.6919 11.8 10.5 11.5985 10.5 11.35V10.45Z"
              fill="#515151"
            />
            <path
              d="M10.5 13.45C10.5 13.2015 10.6919 13 10.9286 13H11.7857C12.0224 13 12.2143 13.2015 12.2143 13.45V14.35C12.2143 14.5985 12.0224 14.8 11.7857 14.8H10.9286C10.6919 14.8 10.5 14.5985 10.5 14.35V13.45Z"
              fill="#515151"
            />
            <path
              d="M17 11.45C17 11.2015 17.1919 11 17.4286 11H18.2857C18.5224 11 18.7143 11.2015 18.7143 11.45V12.35C18.7143 12.5985 18.5224 12.8 18.2857 12.8H17.4286C17.1919 12.8 17 12.5985 17 12.35V11.45Z"
              fill="#515151"
            />
            <path
              d="M17 14.45C17 14.2015 17.1919 14 17.4286 14H18.2857C18.5224 14 18.7143 14.2015 18.7143 14.45V15.35C18.7143 15.5985 18.5224 15.8 18.2857 15.8H17.4286C17.1919 15.8 17 15.5985 17 15.35V14.45Z"
              fill="#515151"
            />
            <path
              d="M17 17.45C17 17.2015 17.1919 17 17.4286 17H18.2857C18.5224 17 18.7143 17.2015 18.7143 17.45V18.35C18.7143 18.5985 18.5224 18.8 18.2857 18.8H17.4286C17.1919 18.8 17 18.5985 17 18.35V17.45Z"
              fill="#515151"
            />
          </svg>
        );
      }

      case Icons.UP_ARROW: {
        return (
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            viewBox="0 0 16 16"
            fill="none"
          >
            <path
              d="M8 13.5L8 3"
              stroke="#04A451"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
            <path
              d="M3.5 7.5L8 3L12.5 7.5"
              stroke="#04A451"
              strokeWidth="2.5"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        );
      }

      case Icons.INTEL: {
        return (
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M25.667 3C26.7716 3 27.667 3.89543 27.667 5V7.33333C27.667 8.4379 26.7716 9.33333 25.667 9.33333C24.5624 9.33333 23.667 8.4379 23.667 7.33333V5C23.667 3.89543 24.5624 3 25.667 3ZM9.31944 9.65245C10.1005 8.8714 11.3668 8.8714 12.1479 9.65245L13.7812 11.2858C14.5623 12.0668 14.5623 13.3332 13.7812 14.1142C13.0002 14.8953 11.7338 14.8953 10.9528 14.1142L9.31944 12.4809C8.5384 11.6998 8.5384 10.4335 9.31944 9.65245ZM42.0145 9.65245C42.7956 10.4335 42.7956 11.6998 42.0145 12.4809L40.3812 14.1142C39.6002 14.8953 38.3338 14.8953 37.5528 14.1142C36.7717 13.3332 36.7717 12.0668 37.5528 11.2858L39.1861 9.65245C39.9672 8.8714 41.2335 8.8714 42.0145 9.65245ZM2.66699 26C2.66699 24.8954 3.56242 24 4.66699 24H7.00033C8.10489 24 9.00033 24.8954 9.00033 26C9.00033 27.1046 8.10489 28 7.00033 28H4.66699C3.56242 28 2.66699 27.1046 2.66699 26ZM42.3337 26C42.3337 24.8954 43.2291 24 44.3337 24H46.667C47.7716 24 48.667 24.8954 48.667 26C48.667 27.1046 47.7716 28 46.667 28H44.3337C43.2291 28 42.3337 27.1046 42.3337 26Z"
              fill="#928CDA"
            />
            <path
              d="M17.9683 15.3186C20.2101 13.7028 22.9035 12.8333 25.667 12.8333C28.4304 12.8333 31.1238 13.7028 33.3657 15.3186C35.6075 16.9345 37.2841 19.2147 38.158 21.8363C39.0319 24.458 39.0587 27.2881 38.2348 29.9259C37.4212 32.5301 35.8191 34.8165 33.6509 36.4698C33.5566 36.5629 33.4742 36.6437 33.4014 36.7151C33.1115 36.9992 32.9748 37.1331 32.852 37.2937C32.7432 37.4358 32.6281 37.6267 32.4567 38.141C32.2525 38.7535 31.6793 39.1667 31.0337 39.1667H20.3003C19.6547 39.1667 19.0815 38.7535 18.8773 38.141C18.7058 37.6267 18.5908 37.4358 18.482 37.2937C18.3592 37.1331 18.2225 36.9992 17.9326 36.715C17.8598 36.6437 17.7774 36.5629 17.6831 36.4699C15.5149 34.8165 13.9127 32.5301 13.0992 29.9259C12.2753 27.2881 12.3021 24.458 13.176 21.8363C14.0499 19.2147 15.7265 16.9345 17.9683 15.3186Z"
              fill="#928CDA"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M19.5003 42.9998C19.5003 42.1714 20.1719 41.4998 21.0003 41.4998H30.3337C31.1621 41.4998 31.8337 42.1714 31.8337 42.9998C31.8337 44.7301 30.8549 46.1235 29.7155 47.0257C28.5781 47.9262 27.0901 48.5 25.667 48.5C24.2439 48.5 22.7559 47.9262 21.6185 47.0257C20.4791 46.1235 19.5003 44.7301 19.5003 42.9998Z"
              fill="#928CDA"
            />
          </svg>
        );
      }

      case Icons.KITS: {
        return (
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M45.4851 19.013C44.3013 17.8291 42.6957 17.1641 41.0215 17.1641H38C37.1716 17.1641 36.5 17.8356 36.5 18.6641V23.998C36.5 28.6925 32.6944 32.498 28 32.498H20.1673C19.3389 32.498 18.6673 33.1696 18.6673 33.998C18.6673 35.7744 19.7706 37.1488 20.9323 38.0025C22.1023 38.8624 23.6103 39.4141 24.9798 39.4141H38.796L44.7733 45.3914C45.2023 45.8204 45.8475 45.9487 46.408 45.7165C46.9685 45.4844 47.334 44.9374 47.334 44.3307V23.4766C47.334 21.8024 46.6689 20.1968 45.4851 19.013Z"
              fill="#00B152"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M5.94957 8.11363C7.19786 6.86534 8.8909 6.16406 10.6562 6.16406H27.8438C29.6091 6.16406 31.3021 6.86534 32.5504 8.11363C33.7987 9.36192 34.5 11.055 34.5 12.8203V23.1328C34.5 24.8982 33.7987 26.5912 32.5504 27.8395C31.3021 29.0878 29.6091 29.7891 27.8438 29.7891H12.9963L6.56066 36.2247C6.13166 36.6537 5.48649 36.7821 4.92597 36.5499C4.36546 36.3177 4 35.7708 4 35.1641V12.8203C4 11.055 4.70128 9.36192 5.94957 8.11363Z"
              fill="#00B152"
            />
          </svg>
        );
      }

      case Icons.PORTFOLIO: {
        return (
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              d="M8.60693 22.034C8.60693 19.4699 10.6856 17.3912 13.2498 17.3912H23.324C24.826 17.3912 26.2353 18.1178 27.1064 19.3415L28.718 21.6055H38.7498C41.314 21.6055 43.3926 23.6842 43.3926 26.2484V39.6769C43.3926 42.2411 41.314 44.3198 38.7498 44.3198H13.2498C10.6856 44.3198 8.60693 42.2411 8.60693 39.6769V22.034Z"
              fill="#4673D1"
            />
            <path
              d="M10.6071 12.2483C10.6071 9.68415 12.6858 7.60547 15.25 7.60547H31.75C34.3142 7.60547 36.3929 9.68415 36.3929 12.2483V18.4983C36.3929 19.2676 35.7693 19.8912 35 19.8912H31.107C30.6843 19.8912 30.2845 19.6993 30.0202 19.3695L27.8283 16.6349C27.2041 15.8562 26.2523 15.4055 25.2462 15.4124C22.4092 15.432 20.0772 15.4205 17.5558 15.4082C15.8599 15.3999 14.0784 15.3912 12 15.3912C11.2307 15.3912 10.6071 14.7676 10.6071 13.9983V12.2483Z"
              fill="#4673D1"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M38.4999 19.9625V12.9983C40.0581 12.9983 41.3213 14.2614 41.3213 15.8196V19.9625H38.4999Z"
              fill="#4673D1"
            />
          </svg>
        );
      }

      case Icons.CLIENTS: {
        return (
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M12 18.5C12 13.5294 16.0294 9.5 21 9.5C25.9705 9.5 30 13.5294 30 18.5C30 23.4706 25.9705 27.5 21 27.5C16.0294 27.5 12 23.4706 12 18.5Z"
              fill="#FB913A"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M31.0213 10.2451C31.353 9.77127 31.9277 9.53044 32.4982 9.62614C36.7559 10.3405 40 14.0408 40 18.5018C40 22.9628 36.7559 26.6631 32.4982 27.3774C31.937 27.4715 31.3708 27.24 31.0364 26.7797C30.702 26.3193 30.6568 25.7093 30.9199 25.2047C32.4493 22.2707 33.1024 20.214 33.102 18.3203C33.1016 16.4417 32.4574 14.5159 30.9447 11.8446C30.6597 11.3413 30.6895 10.7189 31.0213 10.2451Z"
              fill="#FB913A"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M8.59009 38.7834C9.76628 34.8965 13.1386 31.375 17.2498 31.375H24.75C28.8611 31.375 32.2336 34.8964 33.4099 38.7834C33.9199 40.4689 32.5497 41.875 31.0598 41.875H10.9402C9.45022 41.875 8.08004 40.4689 8.59009 38.7834Z"
              fill="#FB913A"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M33.4142 32.1925C33.6706 31.6908 34.1865 31.375 34.75 31.375C38.8611 31.375 42.2336 34.8964 43.4099 38.7834C43.9199 40.4689 42.5497 41.875 41.0598 41.875H38C37.2785 41.875 36.6593 41.3614 36.5259 40.6524C36.2415 39.1417 35.9456 38.0643 35.5129 37.0612C35.0796 36.0567 34.4826 35.065 33.5345 33.754C33.2043 33.2974 33.1579 32.6943 33.4142 32.1925Z"
              fill="#FB913A"
            />
          </svg>
        );
      }

      case Icons.LOGS: {
        return (
          <svg
            width="52"
            height="52"
            viewBox="0 0 52 52"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
          >
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M11.6191 13.6187C11.6191 10.8047 13.9004 8.52344 16.7144 8.52344H27.7574C29.0834 8.52344 30.3552 9.05022 31.2929 9.9879L38.8908 17.5858C39.2658 17.9609 39.4766 18.4696 39.4766 19V24.5C39.4766 25.6046 38.5811 26.5 37.4766 26.5C36.372 26.5 35.4766 25.6046 35.4766 24.5V21H32C29.2386 21 27 18.7614 27 16V12.5234H16.7144C16.1095 12.5234 15.6191 13.0138 15.6191 13.6187V38.3806C15.6191 38.9855 16.1095 39.4758 16.7144 39.4758L22 39.4758C23.1046 39.4758 24 40.3712 24 41.4758C24 42.5804 23.1046 43.4758 22 43.4758L16.7144 43.4758C13.9004 43.4758 11.6191 41.1946 11.6191 38.3806V13.6187ZM31 15.3519V16C31 16.5523 31.4477 17 32 17H32.6481L31 15.3519Z"
              fill="#51BFE1"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.8096 26C17.8096 24.8954 18.705 24 19.8096 24H29C30.1046 24 31 24.8954 31 26C31 27.1046 30.1046 28 29 28H19.8096C18.705 28 17.8096 27.1046 17.8096 26Z"
              fill="#51BFE1"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M17.8096 32.1875C17.8096 31.0829 18.705 30.1875 19.8096 30.1875H23C24.1046 30.1875 25 31.0829 25 32.1875C25 33.2921 24.1046 34.1875 23 34.1875H19.8096C18.705 34.1875 17.8096 33.2921 17.8096 32.1875Z"
              fill="#51BFE1"
            />
            <path
              fillRule="evenodd"
              clipRule="evenodd"
              d="M36.334 28.5C31.0873 28.5 26.834 32.7533 26.834 38C26.834 43.2467 31.0873 47.5 36.334 47.5C41.5807 47.5 45.834 43.2467 45.834 38C45.834 32.7533 41.5807 28.5 36.334 28.5ZM37.834 35C37.834 34.1716 37.1624 33.5 36.334 33.5C35.5056 33.5 34.834 34.1716 34.834 35V38C34.834 38.5269 35.1104 39.0152 35.5622 39.2862L38.0622 40.7862C38.7726 41.2125 39.694 40.9821 40.1202 40.2717C40.5464 39.5614 40.3161 38.64 39.6057 38.2138L37.834 37.1507V35Z"
              fill="#51BFE1"
            />
          </svg>
        );
      }

      default:
        return null;
    }
  };
  return (
    <div testid={testid} onClick={onClick} className={className}>
      {renderIcon()}
    </div>
  );
};

Icons.SIGNALS = 'signals';
Icons.INTEL = 'intel';
Icons.KITS = 'kits';
Icons.PORTFOLIO = 'portfolio';
Icons.CLIENTS = 'clients';
Icons.LOGS = 'logs';
Icons.UP_ARROW = 'upArrow';
Icons.CONDO = 'condo';

Icons.propTypes = {
  className: PropTypes.string,
  variant: PropTypes.string,
  color: PropTypes.string,
  onClick: PropTypes.func,
  testid: PropTypes.string,
  svgClass: PropTypes.string,
};

Icons.defaultProps = {
  svgClass: '',
  className: '',
  variant: '',
  color: '',
  testid: undefined,
  onClick: () => {},
};
